module.exports = __webpack_public_path__ + "static/avatar_rudy-fccb56044dd6d933fc149eda0c5e1608.png";